import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrLU: CultureInfo = {
  name: 'fr-LU',
  displayName: 'French (Luxembourg)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-LU',
  parent: CultureInfoFr
};
